import type { ReactNode } from "react";

type Kind = "allow" | "warn" | "rewrite" | "block" | "neutral";

export function Pill({ kind, children, title }: { kind: Kind; children: ReactNode; title?: string }) {
  return <span className={`sg-annotation ${kind}`} title={title}>{children}</span>;
}

export function actionPillKind(a: string): Kind {
  switch (a) {
    case "allow": return "allow";
    case "warn": return "warn";
    case "suggest_rewrite": return "rewrite";
    case "block": return "block";
    default: return "neutral";
  }
}

export function actionLabel(a: string): string {
  if (a === "suggest_rewrite") return "Rewrite";
  return a.charAt(0).toUpperCase() + a.slice(1);
}
